import { createContext, useContext, useState, useCallback } from "react";

const AuthContext = createContext(null);

export const AuthProvider = ({ children }) => {
  // Store token in memory only - not localStorage (prevents XSS attacks)
  const [token, setToken] = useState(null);
  const [username, setUsername] = useState(null);

  const login = useCallback((newToken, newUsername) => {
    setToken(newToken);
    setUsername(newUsername);
  }, [setToken, setUsername]);

  const logout = useCallback(() => {
    setToken(null);
    setUsername(null);
  }, [setToken, setUsername]);

  const isAuthenticated = useCallback(() => {
    return token !== null;
  }, [token]);

  const value = {
    token,
    username,
    login,
    logout,
    isAuthenticated
  };

  return (
    <AuthContext.Provider value={value}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => {
  const context = useContext(AuthContext);
  if (!context) {
    throw new Error("useAuth must be used within an AuthProvider");
  }
  return context;
};

export default AuthContext;
